import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../pages/login.vue'
import home from '../pages/home.vue'

import deviceContent from "@/pages/deviceContent/index.vue"
import imgScreen from '../pages/deviceContent/imgScreen.vue'
import indexScreen from '../pages/deviceContent/indexScreen.vue'
import navScreen from '../pages/deviceContent/navScreen.vue'
import amap from '../pages/amap.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login.vue')

  },

  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/home.vue'),
    children: [
      {
        path: '/home/deviceContent',
        name: 'deviceContent',
        component: () => import('@/pages/deviceContent/index.vue'),
      },
      {
        path: '/home/navScreen',
        name: 'navScreen',
        component: () => import('@/pages/deviceContent/navScreen.vue')
      },

      {
        path: '/home/amap',
        name: 'amap',
        component: () => import('@/pages/amap.vue')

      },
    ],

  },

]



const router = new VueRouter({
  routes
})


router.beforeEach((to, from, next) => {
  // 放行登录页面
  if (to.path === '/login') {
    return next()
  }
  // 获取token
  const tokenStr = localStorage.getItem("token");
  if (!tokenStr) {
    return next('/login')
  } else {
    next()
  }
})




export default router
